export default __webpack_public_path__ + "static/media/arctic-facet.7e84aa32.png";